// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2jqkc","nameLoader":"Header_nameLoader__3c4e2"};